import Vue from 'vue';
import Vuex from 'vuex';
import { axios } from '../plugins/http-axios';
import Uri, { uri } from '@/store/uri';
import error from '@/store/error';
import loader from '@/store/loader';
import system from '@/store/system';
import color from '@/store/color';
import i18n from '@/store/i18n';
import user from '@/store/user';
import bank from '@/store/bank';
import env from '@/store/env';
import app from '@/store/app';
import actions from '@/store/actions';
import paging from '@/store/paging';
import success from '@/store/success';
import questionnaire from '@/store/formBuilder';
import updateSystem from '@/store/updateSystem';
import sound from '@/store/sound';
import certificates from '@/store/certificates';

Vue.use(Vuex);
// import {FormBuilderState} from "@/store/formBuilder";
interface IDocumentType2 {
  id: number;
  legalType: string;
  name: string;
}

interface IDocumentTypeItem {
  id: number;
  name: string;
  subtype:{
    id: string;
    name: string;
  }
  [key:string]: any;
}

export interface IDocumentTypeAll {
  id: string;
  name: string;
  items: IDocumentTypeItem[];
}

export interface RootState {
  uri: Uri;
  // json?: FormBuilderState;
  documentTypes: IDocumentType2[];
  documentTypesAll: IDocumentTypeAll[];
}

const store = new Vuex.Store<RootState>({
  //     const store: StoreOptions<RootState> = {
  state: {
    uri: uri,
    documentTypes: [],
    documentTypesAll: [],
  },
  mutations: {},
  actions: {
    async logout({ commit, dispatch, state }) {
      commit('setAuthorized');
      // dispatch('closeSocket');
      // commit('setApps');
      // commit('step3/setId');
      clearLocalStorage();

      return axios
        .get(state.uri.logout)
        .then(() => {
          return true;
        })
        .catch((e) => {
          e.uri = state.uri.logout;
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    async getDocumentTypesAll({ dispatch, state, getters }, url = getters.uri.documenttype) {
      if (getters.documentTypesAll.length) {
        return Promise.resolve(getters.documentTypesAll);
      }

      return axios
        .get<IDocumentTypeAll[]>(url)
        .then((resp) => {
          state.documentTypesAll = resp.data;
          return Promise.resolve(getters.documentTypesAll);
        });
    },
    async getDocumentTypes({ dispatch, state, getters }, { keys = [], url = getters.uri.documenttype } = {}) {
      if (!keys.length) {
        return;
      }

      return axios
        .get<IDocumentTypeAll[]>(url)
        .then((resp) => {
          state.documentTypes = resp.data
            .filter((docType) => {
              return keys.includes(docType.id);
            })
            .reduce((sum, docType) => {
              return [
                ...sum,
                ...docType?.items.map((doc: any) => {
                  return {
                    specialType: doc?.specialType !== undefined ? doc.specialType : null,
                    legalType: docType.id,
                    name: doc.name,
                    id: doc.id,
                  };
                }),
              ];
            }, [] as IDocumentType2[]);
        });
    },
  },
  getters: {
    uri: (state) => state.uri,
    documentTypes: (state):IDocumentType2[] => state.documentTypes,
    documentTypesAll: (state):IDocumentTypeAll[] => state.documentTypesAll,
  },
  modules: {
    error,
    loader,
    system,
    color,
    i18n,
    user,
    bank,
    env,
    app,
    actions,
    paging,
    success,
    questionnaire,
    updateSystem,
    sound,
    certificates,
  },
});

if (process.env.NODE_ENV !== 'production') {
  store.subscribeAction((action, state) => {
    console.warn('Action:', action.type, action.payload);
  });
  store.subscribe((mutation, state) => {
    console.warn('Mutation:', mutation.type, mutation.payload);
  });
}

// export default new Vuex.Store<RootState>(store);
export default store;


function clearLocalStorage() {
  const expandAsideMenu = localStorage.getItem('expandAsideMenu');
  localStorage.clear();
  if (expandAsideMenu) {
    localStorage.setItem('expandAsideMenu', expandAsideMenu)
  }
}
